/* mw-avise: captura "avise quando voltar" na PDP esgotada (FE/J18). Carrega SO
 * neste template e SO quando product.available == false (a section so emite o
 * bloco e o <script> nesse caso); budget proprio, gate em
 * scripts/check-js-budget.mjs. Envia POST same-origin pelo App Proxy assinado
 * (/apps/curador/estoque-aviso); contrato do painel: {email, variantId, handle,
 * titulo} -> {ok:true} | {ok:false, erro}. Single opt-in (aviso pedido, nao
 * marketing). Progressive enhancement: sem JS o <form> ainda posta nativo.
 * Estados: repouso, enviando, confirmado, erro de formato, erro de servidor. */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-mw-avise]');
  if (!raiz) return;
  var form = raiz.querySelector('[data-mw-avise-form]');
  var corpo = raiz.querySelector('[data-mw-avise-corpo]');
  var ok = raiz.querySelector('[data-mw-avise-ok]');
  var email = raiz.querySelector('[data-mw-avise-email]');
  var botao = raiz.querySelector('[data-mw-avise-botao]');
  var erro = raiz.querySelector('[data-mw-avise-erro]');
  if (!form || !corpo || !ok || !email || !botao || !erro) return;

  var T = {};
  var i18n = raiz.querySelector('#mw-avise-i18n');
  try { T = JSON.parse(i18n.textContent); } catch (e) { return; }

  var CATALOGO = raiz.getAttribute('data-catalogo-url') || '/collections/vinhos';
  var TITULO = raiz.getAttribute('data-titulo') || '';
  var ACAO = form.getAttribute('action');
  var RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var enviando = false;

  function fmt(str, map) {
    return (str || '').replace(/%(\w+)/g, function (_, k) { return map[k] != null ? map[k] : ''; });
  }
  function val(nome) {
    var el = form.querySelector('[name="' + nome + '"]');
    return el ? el.value : '';
  }
  function limparErro() {
    erro.textContent = '';
    erro.hidden = true;
    email.removeAttribute('aria-invalid');
  }
  function mostrarErro(msg, foco) {
    erro.textContent = msg;
    erro.hidden = false;
    email.setAttribute('aria-invalid', 'true');
    if (foco) { try { email.focus(); } catch (e) {} }
  }
  function setEnviando(on) {
    enviando = on;
    botao.disabled = on;
    if (on) {
      botao.setAttribute('aria-disabled', 'true');
      botao.textContent = T.enviando || botao.textContent;
    } else {
      botao.removeAttribute('aria-disabled');
      botao.textContent = T.botao || botao.textContent;
    }
  }
  function confirmar() {
    corpo.hidden = true;
    while (ok.firstChild) ok.removeChild(ok.firstChild);
    var linha = document.createElement('div');
    linha.className = 'mw-pdp-avise-ok-linha';
    var losango = document.createElement('span');
    losango.className = 'mw-pdp-losango';
    losango.setAttribute('aria-hidden', 'true');
    var msg = document.createElement('p');
    msg.className = 'mw-pdp-avise-ok-msg';
    msg.textContent = fmt(T.confirmado, { nome: TITULO });
    linha.appendChild(losango);
    linha.appendChild(msg);
    ok.appendChild(linha);
    if (T.outro_rotulo) {
      var link = document.createElement('a');
      link.className = 'mw-pdp-avise-outro';
      link.href = CATALOGO;
      link.textContent = T.outro_rotulo;
      ok.appendChild(link);
    }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (enviando) return;
    var valor = (email.value || '').trim();
    limparErro();
    if (!RE_EMAIL.test(valor)) { mostrarErro(T.erro_formato, true); return; }
    setEnviando(true);
    fetch(ACAO, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ email: valor, variantId: val('variantId'), handle: val('handle'), titulo: TITULO })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { j._ok = r.ok; return j; });
    }).then(function (j) {
      setEnviando(false);
      if (j && j.ok) { confirmar(); return; }
      if (j && j.erro === 'email_invalido') { mostrarErro(T.erro_formato, true); return; }
      mostrarErro(T.erro_servidor, true);
    }).catch(function () {
      setEnviando(false);
      mostrarErro(T.erro_servidor, true);
    });
  });

  /* validacao gentil no blur (nao a cada tecla, spec a11y); sem roubar foco */
  email.addEventListener('blur', function () {
    var valor = (email.value || '').trim();
    if (valor && !RE_EMAIL.test(valor)) mostrarErro(T.erro_formato, false);
    else if (!erro.hidden && RE_EMAIL.test(valor)) limparErro();
  });
  email.addEventListener('input', function () {
    if (!erro.hidden) limparErro();
  });
})();
